import { api } from './api';

export interface DistrictRow {
  id: number;
  rank: number;
  districtName: string;
  totalHours: number;
  totalClients: number;
  totalReviews: number;
  totalScore: number;
  lastUpdated: string;
}

export interface DistrictsResponse {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  districts: DistrictRow[];
}

export interface GetDistrictsParams {
  limit?: number;
  offset?: number;
  districtName?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const districts = {
  getByEventId: async (
    eventId: number,
    params?: GetDistrictsParams
  ): Promise<DistrictsResponse> => {
    const response = await api.get<DistrictsResponse>(`/leaderboard-events/${eventId}/districts`, {
      params,
    });
    return response;
  },
};
